var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: "39px",
    viewBox: "0 0 508.07 398.17",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 463,
    y1: 205.16,
    x2: 182.39,
    y2: 742.62,
    gradientTransform: "translate(0 -198)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ffa3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dc1fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 340.31,
    y1: 141.1,
    x2: 59.71,
    y2: 678.57,
    gradientTransform: "translate(0 -198)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ffa3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dc1fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 401.26,
    y1: 172.92,
    x2: 120.66,
    y2: 710.39,
    gradientTransform: "translate(0 -198)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ffa3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dc1fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0) scale(1,1)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linear-gradient)",
    d: "M84.53,358.89A16.63,16.63,0,0,1,96.28,354H501.73a8.3,8.3,0,0,1,5.87,14.18l-80.09,80.09a16.61,16.61,0,0,1-11.75,4.86H10.31A8.31,8.31,0,0,1,4.43,439Z",
    transform: "translate(-1.98 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linear-gradient-2)",
    d: "M84.53,59.85A17.08,17.08,0,0,1,96.28,55H501.73a8.3,8.3,0,0,1,5.87,14.18l-80.09,80.09a16.61,16.61,0,0,1-11.75,4.86H10.31A8.31,8.31,0,0,1,4.43,140Z",
    transform: "translate(-1.98 -55)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linear-gradient-3)",
    d: "M427.51,208.42a16.61,16.61,0,0,0-11.75-4.86H10.31a8.31,8.31,0,0,0-5.88,14.18l80.1,80.09a16.6,16.6,0,0,0,11.75,4.86H501.73a8.3,8.3,0,0,0,5.87-14.18Z",
    transform: "translate(-1.98 -55)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSol);
export default __webpack_public_path__ + "static/media/sol.a8b3b1e2f35b3e53a6130bc1c4ae3afa.svg";
export { ForwardRef as ReactComponent };